import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { userPointsQueryOptions } from './query'
import { Address, zeroAddress } from 'viem'
import { UserPoints } from '../types'

export type UseUserPointsResult = Pick<UseQueryResult<UserPoints>, 'data' | 'isLoading' | 'error'>

export function useUserPoints({ account, chainId }: { account?: Address; chainId: number }): UseUserPointsResult {
  const result = useQuery({
    ...userPointsQueryOptions({ account: account ?? zeroAddress, chainId }),
    enabled: !!account,
  })

  return {
    ...result,
    data: result.data,
  }
}
